export default "__VITE_ASSET__CqtN0xuT__"